import CoreApiTokenManager from '../lib/CoreApiTokenManager';
import { networkErrorApiWrapper } from '../lib/NetworkErrorHandler';
import { urnApiWrapper } from '../lib/urnApiWrapper';
import { config } from '../../config';
// @ts-nocheck
export type ThenArg<T> =
  T extends Promise<infer U>
    ? U
    : T extends (...args: any[]) => Promise<infer U>
      ? U
      : T;

type QueryParameters = {
  [key: string]:
    | string
    | number
    | string[]
    | number[]
    | boolean
    | boolean[]
    | undefined;
};

export type Error = {
  statusCode: number;
  name: string;
  userinfo?: string;
};

export type BaseAccount = {
  name: string;
  surname: string;
  created_at: string;
};

export type Account = {
  name: string;
  surname: string;
  created_at: string;
  acc_id: string;
  email?: string;
  verified?: boolean;
  verified_email?: boolean;
};

export type ClientAccount = {
  name: string;
  surname: string;
  created_at: string;
  client_acc_id: string;
  client_id: string;
  verified?: boolean;
};

export type AdminAccount = {
  name: string;
  surname: string;
  created_at: string;
  acc_id: string;
  email?: string;
  verified?: boolean;
  verified_email?: boolean;
};

export type AdminAccountList = {
  accounts: Array<Account>;
};

export type AdminAccountPatch = {
  verified: boolean;
};

export type AccountRolesInput = {
  roles: Array<string>;
};

export type GamificationTier = {
  tier?: {
    tier_id: string;
    title: string;
    min_points: number;
    max_points: number;
  };
};

export type Role = {
  role_id: string;
  name?: string;
  description?: string;
};

export type RoleInput = {
  name: string;
  description?: string;
};

export type RoleCreateInput = {
  role_id: string;
  name: string;
  description?: string;
};

export type PermissionReference = {
  client_id: string;
  permission: string;
};

export type Permission = {
  client_id: string;
  permission: string;
  client_name?: string;
  permission_name?: string;
  permission_description?: string;
};

export type ClientPermissionList = {
  client_permissions: Array<ClientPermission>;
};

export type ClientPermission = {
  permission: string;
  name?: string;
  description?: string;
};

export type ClientPermissionsEditInput = Array<{
  permission: string;
  values: {
    permission?: string;
    name?: string;
    description?: string;
  };
}>;

export type ClientScopeList = {
  client_scopes: Array<ClientScope>;
};

export type ClientScope = {
  scope: string;
};

export type MqttAcl = {
  acl: Array<MqttAclEntry>;
};

export type MqttAclEntry = {
  id: number;
  topic: string;
  action: "all" | "publish" | "subscribe";
  permission: "allow" | "deny";
  priority?: number;
};

export type MqttAclEntryFields = {
  topic: string;
  action: "all" | "publish" | "subscribe";
  permission: "allow" | "deny";
  priority?: number;
};

export type MqttAclEntryEdit = {
  id: number;
  topic?: string;
  action?: "all" | "publish" | "subscribe";
  permission?: "allow" | "deny";
  priority?: number;
};

export type AccountList = {
  accounts: Array<Account>;
};

export type ClientAccountList = {
  accounts: Array<ClientAccount>;
};

export type AppAccount = {
  client_acc_id?: string;
  acc_id?: string;
  name?: string;
  surname?: string;
};

export type RoleList = {
  roles: Array<Role>;
};

export type PermissionList = {
  permissions: Array<Permission>;
};

export type UserPrmResponse = {
  roles: Array<Role>;
  permissions: Array<Permission>;
};

export type AdminClientList = {
  clients: Array<{
    client_id: string;
    name: string;
    created_at: string;
    secret?: string;
  }>;
};

export type Client = {
  client_id: string;
  name: string;
  created_at: string;
  verified_accounts_only: boolean;
  secret?: string;
  open_data_uri?: string;
};

export type ClientCreateInput = {
  client_id: string;
  verified_accounts_only: boolean;
  name: string;
  open_data_uri?: string;
};

export type ClientUpdateInput = {
  name?: string;
  verified_accounts_only?: boolean;
  secret?: boolean;
  open_data_uri?: string;
};

export type ClientMessage = {
  message_id: string;
  type: "info" | "warning" | "error";
  text: string;
  audience: "all" | "authenticated" | "role";
  active: boolean;
  dismissible: boolean;
  valid_from?: string;
  valid_to?: string;
  role_ids: Array<string>;
  updated_at: string;
  updated_by?: string;
};

export type ClientMessageInput = {
  type: "info" | "warning" | "error";
  text: string;
  audience?: "all" | "authenticated" | "role";
  active?: boolean;
  dismissible?: boolean;
  valid_from?: string;
  valid_to?: string;
  role_ids?: Array<string>;
};

export type ClientMessages = {
  messages: Array<ClientMessage>;
};

export type PublicClientMessage = {
  message_id: string;
  type: "info" | "warning" | "error";
  text: string;
  dismissible: boolean;
  valid_to?: string;
  updated_at: string;
};

export type ClientMessagesResponse = {
  messages: Array<PublicClientMessage>;
  version: string;
  next_change_at?: string;
};

export type ClientRolesInput = {
  roles: Array<string>;
};

export type ApiKey = {
  api_key: string;
  description?: string;
  created_at: string;
  client_device_id?: string;
};

export type ApiKeysList = {
  api_keys: Array<ApiKey>;
};

export type ApiKeysDeleteInput = {
  api_keys: Array<string>;
};

export type RedirectUrisList = {
  redirect_uris: Array<RedirectUri>;
};

export type RedirectUri = {
  type: "login" | "logout";
  redirect_uri: string;
};

export type RedirectUriEdit = {
  type: "login" | "logout";
  redirect_uri: string;
  old_redirect_uri: string;
};

export type Delegation = {
  client_id: string;
  created_at: string;
  valid_from?: string;
  valid_to?: string;
};

export type DelegationList = {
  delegations: Array<Delegation>;
};

export type DelegationInput = {
  target_client_id: string;
  client_id: string;
  valid_from?: string;
  valid_to?: string;
};

export type DelegationEdit = {
  client_id: string;
  valid_from?: string;
  valid_to?: string;
};

export type ClientDevice = {
  device_id: string;
  client_id: string;
  api_key?: string;
  title?: string;
  description?: string;
  location?: Location;
  created_at: string;
};

export type ClientDeviceCreateInput = {
  deviceId: string;
  title?: string;
  description?: string;
  location?: string;
};

export type ClientDeviceUpdateInput = {
  title?: string;
  description?: string;
  location?: string;
};

export type GamificationAccount = {
  account_id: number;
  account_type: "general";
  name: string;
  description?: string;
  balance: number;
  created_at: string;
};

export type GamificationTransaction = {
  transaction_id: number;
  transaction_type: string;
  client_id?: string;
  description: string;
  points: number;
  original_points?: number;
  status: "confirmed" | "reserved" | "cancelled" | "expired";
  expires_at?: string;
  payload?: {};
  created_at: string;
};

export type AppGamificationTransactionRequest = {
  client_acc_id: string;
  transaction_type: string;
  description: string;
  points: number;
  status: "confirmed";
  payload?: {};
};

export type BenefitListItem = {
  benefit_id: string;
  title: string;
  description?: string;
  points: number;
  image?: string;
  client_id: string;
  inserted_at: string;
};

export type BenefitDetail = {
  benefit_id: string;
  title: string;
  description?: string;
  points: number;
  image?: string;
  client_id: string;
  inserted_at: string;
};

export type BenefitCreate = {
  client_id: string;
  title: string;
  description?: string;
  points: number;
  image?: File;
};

export type BenefitUpdate = {
  title?: string;
  description?: string;
  points?: number;
  image?: File;
};

export type ConsentStatus = "granted" | "denied" | "undecided";

export type UserConsentDetail = {
  user_consent_id: string;
  status: ConsentStatus;
  client_id: string;
  consent_id: string;
  version: number;
  inserted_at: string;
};

export type UserRequestType = "delete" | "export";

export type UserRequestStatus = "pending" | "resolved" | "processing" | "error";

export type UserRequest = {
  user_request_id: string;
  client_id: string;
  client_acc_id: string;
  type: UserRequestType;
  status: UserRequestStatus;
  app_data_id: string;
  payload?: {};
  callback_url?: string;
  inserted_at: string;
  processed_at?: string;
  resolved_at?: string;
};

export type UserRequestWithAccId = {
  user_request_id: string;
  client_id: string;
  client_acc_id: string;
  type: UserRequestType;
  status: UserRequestStatus;
  app_data_id: string;
  payload?: {};
  callback_url?: string;
  inserted_at: string;
  processed_at?: string;
  resolved_at?: string;
  acc_id?: string;
};

export type Location = {
  type: "Point";
  coordinates: Array<number>;
};

class ApiError {
  public message: string;
  public details: Error | null = null;

  constructor(message: string) {
    this.message = message;
  }
}

/**
 * Centralized Core API support for DataHub services.
 * @class CoreApi
 * @param {(string)} [domainOrOptions] - The project domain.
 */
class CoreApi {
  protected baseUrl: string = "";
  protected headers: { name: string; value: string }[] = [];
  protected token: string = "";

  serializeQueryParams(parameters: QueryParameters) {
    return Object.keys(parameters)
      .reduce((acc: string[], p) => {
        const param = parameters[p];
        if (typeof param === "undefined" || param === "") {
          return acc;
        }

        if (Array.isArray(parameters[p])) {
          return [
            ...acc,
            ...parameters[p].map(
              (v) => `${encodeURIComponent(p)}=${encodeURIComponent(v)}`,
            ),
          ];
        } else {
          return [
            ...acc,
            `${encodeURIComponent(p)}=${encodeURIComponent(
              String(parameters[p]),
            )}`,
          ];
        }
      }, [])
      .join("&");
  }

  protected transformParameter(value: any, transformOperation?: string) {
    switch (transformOperation) {
      case "joinUsingPipes":
        return Array.isArray(value) ? value.join("|") : value;
      default:
        return value;
    }
  }

  public setBaseUrl(baseUrl: string) {
    this.baseUrl = baseUrl;
  }

  public setHeaders(headers: { name: string; value: string }[]) {
    this.headers = headers;
  }

  public setToken(token: string) {
    this.token = token;
  }

  protected appendAuthHeaders(headerParams: Headers) {
    const headers = new Headers(headerParams);
    if (this.token) {
      headers.append("Authorization", `Bearer ${this.token}`);
    }
    return headers;
  }

  private async request(
    method: string,
    url: string,
    body: any,
    headers: Headers = new Headers(),
    queryParameters: QueryParameters = {},
  ) {
    const queryParams =
      queryParameters && Object.keys(queryParameters).length
        ? this.serializeQueryParams(queryParameters)
        : null;
    const urlWithParams = url + (queryParams ? "?" + queryParams : "");

    if (headers.get("Content-Type") === "multipart/form-data") {
      const form = new FormData();
      for (let k in body) {
        const value = body[k];
        if (Array.isArray(value)) {
          value.forEach((v) => {
            form.append(k, v);
          });
        } else {
          form.append(k, value);
        }
      }
      body = form;
    } else if (
      headers.get("Content-Type") === "application/json" &&
      body &&
      Object.keys(body).length > 0
    ) {
      body = JSON.stringify(body);
    } else {
      body = undefined;
    }

    if (headers.get("Content-Type") === "multipart/form-data") {
      headers.delete("Content-Type");
    }

    if (this.headers.length > 0) {
      this.headers.forEach((h) => {
        headers.append(h.name, h.value);
      });
    }

    const response = await fetch(urlWithParams, { method, headers, body });

    if (response.status === 204) return response;

    if (response.ok) {
      const responseContentType =
        (response.headers && response.headers.get("Content-Type")) || "";
      if (responseContentType.includes("application/json")) {
        return response.json();
      }
      return response;
    } else {
      const err = new ApiError(response.statusText);
      err.details = await response.json();
      throw err;
    }
  }

  /**
   * Get current user PRM (role permissions) information divided by oauth clients.
   * @method
   * @name CoreApi#getMePrm
   */
  getMePrm(parameters: {} = {}): Promise<UserPrmResponse> {
    let path = "/me/prm";
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append("Accept", "application/json");

    return this.request(
      "GET",
      `${this.baseUrl}${path}`,
      {},
      headers,
      queryParameters,
    );
  }
  /**
    * Správy aplikácie, do ktorej je používateľ prihlásený, po filtrovaní
podľa cielenia aj okna platnosti. Aplikácia sa berie z tokenu, nie
z parametra, takže sa cez tento endpoint nedá dostať k cieleným
správam inej aplikácie.

Vracia `audience: all` aj `authenticated`, a z cielených na rolu tie,
ktorých rolu volajúci má.

    * @method
    * @name CoreApi#getMeMessages
    */
  getMeMessages(parameters: {} = {}): Promise<ClientMessagesResponse> {
    let path = "/me/messages";
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append("Accept", "application/json");

    return this.request(
      "GET",
      `${this.baseUrl}${path}`,
      {},
      headers,
      queryParameters,
    );
  }
  /**
   * Get current user's gamification tier information.
   * @method
   * @name CoreApi#meGetGamificationTier
   */
  meGetGamificationTier(parameters: {} = {}): Promise<GamificationTier> {
    let path = "/me/gamification/tier";
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append("Accept", "application/json");

    return this.request(
      "GET",
      `${this.baseUrl}${path}`,
      {},
      headers,
      queryParameters,
    );
  }
  /**
    * Získa zoznam všetkých gamifikačných účtov patriacich aktuálnemu používateľovi spolu s ich aktuálnym saldom.

Saldo sa vypočítava ako súčet všetkých transakcií (pozitívnych aj negatívnych bodov) pre daný účet.
Každý používateľ môže mať viacero typov účtov (napr. hlavný účet, sezónny účet, atď.).

**Príklad použitia:**
- Zobrazenie prehľadu bodov v mobilnej aplikácii
- Dashboard pre používateľa s celkovým stavom bodov

    * @method
    * @name CoreApi#meGetGamificationAccounts
    */
  meGetGamificationAccounts(parameters: {} = {}): Promise<{
    accounts: Array<GamificationAccount>;
  }> {
    let path = "/me/gamification/accounts";
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append("Accept", "application/json");

    return this.request(
      "GET",
      `${this.baseUrl}${path}`,
      {},
      headers,
      queryParameters,
    );
  }
  /**
    * Získa chronologický zoznam transakcií pre konkrétny gamifikačný účet používateľa.

Transakcie sú zoradené od najnovších po najstaršie a zahŕňajú všetky operácie s bodmi:
- Získanie bodov za aktivity (pozitívne hodnoty)
- Využitie bodov za odmeny (negatívne hodnoty)
- Bonusové body a špeciálne akcie

**Cursor-based pagination:**
Endpoint používa efektívne stránkovanie pomocou `cursor` parametra, ktorý obsahuje `transaction_id` poslednej transakcie z predchádzajúcej stránky.

**Filtrovanie:**
- `before` parameter umožňuje získať len transakcie pred určitým dátumom
- `limit` určuje maximálny počet transakcií na stránku (max 100)

**Príklad použitia:**
- História transakcií v mobilnej aplikácii
- Audit log pre správcov
- Export údajov pre reporting

    * @method
    * @name CoreApi#meGetGamificationAccountTransactions
    */
  meGetGamificationAccountTransactions(
    accountId: number,
    parameters: {
      limit?: number;
      cursor?: number;
      before?: string;
    } = {},
  ): Promise<{
    transactions: Array<GamificationTransaction>;
    hasNextPage: boolean;
    nextCursor?: number;
  }> {
    let path = "/me/gamification/accounts/{accountId}/transactions";
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append("Accept", "application/json");

    queryParameters["limit"] = 100;

    if (typeof parameters["limit"] !== "undefined") {
      queryParameters["limit"] = parameters["limit"];
    }

    queryParameters["limit"] = this.transformParameter(
      queryParameters["limit"],
    );

    if (typeof parameters["cursor"] !== "undefined") {
      queryParameters["cursor"] = parameters["cursor"];
    }

    queryParameters["cursor"] = this.transformParameter(
      queryParameters["cursor"],
    );

    if (typeof parameters["before"] !== "undefined") {
      queryParameters["before"] = parameters["before"];
    }

    queryParameters["before"] = this.transformParameter(
      queryParameters["before"],
    );

    path = path.replace("{accountId}", accountId.toString());

    return this.request(
      "GET",
      `${this.baseUrl}${path}`,
      {},
      headers,
      queryParameters,
    );
  }
  /**
    * Vytvorí novú rezerváciu bodov pre budúce využitie.

**Koncept rezervácie:**
Rezervácia umožňuje "zablokovať" body na účte bez ich okamžitého odpočítania.
Užitočné pre scenáre ako:
- Rezervácia zľavy v kaviarni
- Predkúpenie benefitov
- Dočasné blokovanie bodov pre transakcie

**Životný cyklus rezervácie:**
1. **Vytvorenie** - Body sa označia ako rezervované (status: `reserved`)
2. **Automatická expirácia** - Po vypršaní času sa rezervácia zruší
3. **Manuálne potvrdenie** - Rezervácia sa zmení na finálnu transakciu
4. **Manuálne zrušenie** - Body sa okamžite uvoľnia

**Validácie:**
- Účet musí mať dostatok bodov pre rezerváciu
- Počet rezervovaných bodov musí byť záporný
- Čas expirácie sa automaticky nastaví podľa konfigurácie

    * @method
    * @name CoreApi#meCreateGamificationTransaction
    */
  meCreateGamificationTransaction(
    accountId: number,
    parameters: {} = {},
    body: {
      transaction_type: string;
      description: string;
      points: number;
      payload?: {};
    },
  ): Promise<{
    transaction_id: number;
    transaction_type: string;
    client_id?: string;
    description: string;
    points: number;
    original_points?: number;
    status: "confirmed" | "reserved" | "cancelled" | "expired";
    expires_at?: string;
    payload?: {};
    created_at: string;
  }> {
    let path = "/me/gamification/accounts/{accountId}/transactions";
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append("Content-Type", "application/json");
    headers.append("Accept", "application/json");

    path = path.replace("{accountId}", accountId.toString());

    return this.request(
      "POST",
      `${this.baseUrl}${path}`,
      body,
      headers,
      queryParameters,
    );
  }
  /**
    * Vytvorí transakciu z existujúceho benefitu.

    * @method
    * @name CoreApi#meCreateGamificationTransactionFromBenefit
    */
  meCreateGamificationTransactionFromBenefit(
    parameters: {} = {},
    body: {
      benefit_id: string;
      account_id?: number;
    },
  ): Promise<GamificationTransaction> {
    let path = "/me/gamification/transaction-from-benefit";
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append("Content-Type", "application/json");
    headers.append("Accept", "application/json");

    return this.request(
      "POST",
      `${this.baseUrl}${path}`,
      body,
      headers,
      queryParameters,
    );
  }
  /**
    * Získa detail konkrétnej transakcie používateľa.

**Použitie:**
- Zobrazenie detailov rezervácie v aplikácii
- Overenie stavu transakcie pred potvrdením
- Kontrola času expirácie rezervácie
- História konkrétnej operácie

**Bezpečnosť:**
Endpoint vracia len transakcie patriace aktuálne prihlásenému používateľovi.

    * @method
    * @name CoreApi#meGetGamificationTransaction
    */
  meGetGamificationTransaction(
    transactionId: number,
    parameters: {} = {},
  ): Promise<GamificationTransaction> {
    let path = "/me/gamification/transactions/{transactionId}";
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append("Accept", "application/json");

    path = path.replace("{transactionId}", transactionId.toString());

    return this.request(
      "GET",
      `${this.baseUrl}${path}`,
      {},
      headers,
      queryParameters,
    );
  }
  /**
    * Potvrdí rezervovanú transakciu a finalizuje odpočítanie bodov.

**Proces potvrdenia:**
1. Overí, že transakcia existuje a patrí používateľovi
2. Skontroluje, že transakcia má status `reserved`
3. Overí, že rezervácia ešte nevypršala
4. Zmení status na `confirmed`
5. Aktualizuje zostatok na účte

**Typické použitie:**
- Potvrdenie zľavy u obchodníka
- Finalizácia nákupu benefitu
- Dokončenie rezervovanej služby

**Bezpečnosť:**
Endpoint funguje len s transakciami patriacimi aktuálne prihlásenému používateľovi.

    * @method
    * @name CoreApi#meConfirmGamificationTransaction
    */
  meConfirmGamificationTransaction(
    transactionId: number,
    parameters: {} = {},
  ): Promise<{
    transaction_id: number;
    transaction_type: string;
    client_id?: string;
    description: string;
    points: number;
    original_points?: number;
    status: "confirmed" | "reserved" | "cancelled" | "expired";
    expires_at?: string;
    payload?: {};
    created_at: string;
  }> {
    let path = "/me/gamification/transactions/{transactionId}/confirm";
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append("Accept", "application/json");

    path = path.replace("{transactionId}", transactionId.toString());

    return this.request(
      "POST",
      `${this.baseUrl}${path}`,
      {},
      headers,
      queryParameters,
    );
  }
  /**
    * Zruší rezervovanú transakciu a okamžite uvoľní rezervované body.

**Proces zrušenia:**
1. Overí, že transakcia existuje a patrí používateľovi
2. Skontroluje, že transakcia má status `reserved`
3. Uloží pôvodnú hodnotu bodov do `original_points`
4. Nastaví `points` na 0 (uvoľnenie rezervácie)
5. Zmení status na `cancelled`

**Dôvody na zrušenie:**
- Používateľ si rozmyslel
- Benefit už nie je dostupný
- Technická chyba v aplikácii
- Preventívne zrušenie pred expiráciou

**Výsledok:**
Body sa okamžite vrátia na účet a sú dostupné pre ďalšie použitie.

    * @method
    * @name CoreApi#meCancelGamificationTransaction
    */
  meCancelGamificationTransaction(
    transactionId: number,
    parameters: {} = {},
  ): Promise<{
    transaction_id: number;
    transaction_type: string;
    client_id?: string;
    description: string;
    points: number;
    original_points?: number;
    status: "confirmed" | "reserved" | "cancelled" | "expired";
    expires_at?: string;
    payload?: {};
    created_at: string;
  }> {
    let path = "/me/gamification/transactions/{transactionId}/cancel";
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append("Accept", "application/json");

    path = path.replace("{transactionId}", transactionId.toString());

    return this.request(
      "POST",
      `${this.baseUrl}${path}`,
      {},
      headers,
      queryParameters,
    );
  }
  /**
    * Vytvorí novú gamifikačnú transakciu pre externú aplikáciu.

**Autentifikácia:**
Endpoint vyžaduje JWT token s `gamification:transactions:create` permission.
Token musí obsahovať `client_id` pre identifikáciu volajúcej aplikácie.

**DÔLEŽITÉ: Token NESMIE obsahovať `clientAccountId`** - toto je aplikačný endpoint, nie používateľský.

**Mapovanie účtu:**
`client_acc_id` sa mapuje na interný `acc_id` podľa `client_id` z tokenu.
Ak mapovanie neexistuje, endpoint vráti 500 chybu.

**Obmedzenia pre aplikácie:**
- Aplikácie môžu pridávať **len pozitívne body**
- Všetky transakcie sú automaticky **confirmed** (potvrdené)
- Rezervácie nie sú pre aplikácie dostupné

**Typy transakcií:**
- `earned` - Body získané za aktivitu
- `bonus` - Bonusové body od systému
- `adjustment` - Manuálna úprava bodov (len pozitívna)

**Použitie:**
- Odmeny za splnené úlohy v aplikácii
- Bonusy za nákupy alebo aktivity
- Loyality programy a kampane

    * @method
    * @name CoreApi#appCreateGamificationTransaction
    */
  appCreateGamificationTransaction(
    parameters: {} = {},
    body: AppGamificationTransactionRequest,
  ): Promise<GamificationTransaction> {
    let path = "/app/gamification/transactions";
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append("Content-Type", "application/json");
    headers.append("Accept", "application/json");

    return this.request(
      "POST",
      `${this.baseUrl}${path}`,
      body,
      headers,
      queryParameters,
    );
  }
  /**
    * **POZOR: Tento endpoint už nie je aktívny.**

Keďže aplikácie môžu vytvárať len `confirmed` transakcie, 
tento endpoint pre potvrdenie rezervácií už nie je potrebný.

Všetky transakcie vytvorené aplikáciami sú automaticky potvrdené.

    * @method
    * @name CoreApi#appConfirmGamificationTransaction
    */
  appConfirmGamificationTransaction(
    transactionId: number,
    parameters: {} = {},
  ): Promise<{
    transaction_id: number;
    transaction_type: string;
    client_id?: string;
    description: string;
    points: number;
    original_points?: number;
    status: "confirmed" | "reserved" | "cancelled" | "expired";
    expires_at?: string;
    payload?: {};
    created_at: string;
  }> {
    let path = "/app/gamification/transactions/{transactionId}/confirm";
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append("Accept", "application/json");

    path = path.replace("{transactionId}", transactionId.toString());

    return this.request(
      "POST",
      `${this.baseUrl}${path}`,
      {},
      headers,
      queryParameters,
    );
  }
  /**
   * Get list of accounts, registered for application determined from token
   * @method
   * @name CoreApi#getAccounts
   */
  getAccounts(
    parameters: {
      limit?: number;
      q?: string;
      autocomplete?: boolean;
      pagecursor?: Array<string>;
    } = {},
  ): Promise<ClientAccountList> {
    let path = "/accounts";
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append("Accept", "application/json");

    queryParameters["limit"] = 100;

    if (typeof parameters["limit"] !== "undefined") {
      queryParameters["limit"] = parameters["limit"];
    }

    queryParameters["limit"] = this.transformParameter(
      queryParameters["limit"],
    );

    if (typeof parameters["q"] !== "undefined") {
      queryParameters["q"] = parameters["q"];
    }

    queryParameters["q"] = this.transformParameter(queryParameters["q"]);

    if (typeof parameters["autocomplete"] !== "undefined") {
      queryParameters["autocomplete"] = parameters["autocomplete"];
    }

    queryParameters["autocomplete"] = this.transformParameter(
      queryParameters["autocomplete"],
    );

    if (typeof parameters["pagecursor"] !== "undefined") {
      queryParameters["pagecursor"] = parameters["pagecursor"];
    }

    queryParameters["pagecursor"] = this.transformParameter(
      queryParameters["pagecursor"],
    );

    return this.request(
      "GET",
      `${this.baseUrl}${path}`,
      {},
      headers,
      queryParameters,
    );
  }
  /**
   * List all benefits as an admin
   * @method
   * @name CoreApi#adminGetBenefits
   */
  adminGetBenefits(
    parameters: {
      limit?: number;
      pagecursor?: Array<string>;
    } = {},
  ): Promise<{
    benefits: Array<BenefitListItem>;
  }> {
    let path = "/admin/gamification/benefits";
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append("Accept", "application/json");

    queryParameters["limit"] = 100;

    if (typeof parameters["limit"] !== "undefined") {
      queryParameters["limit"] = parameters["limit"];
    }

    queryParameters["limit"] = this.transformParameter(
      queryParameters["limit"],
    );

    if (typeof parameters["pagecursor"] !== "undefined") {
      queryParameters["pagecursor"] = parameters["pagecursor"];
    }

    queryParameters["pagecursor"] = this.transformParameter(
      queryParameters["pagecursor"],
    );

    return this.request(
      "GET",
      `${this.baseUrl}${path}`,
      {},
      headers,
      queryParameters,
    );
  }
  /**
    * Create a new benefit

Chyby, ktoré môže endpoint vrátiť:
- 400: INVALID_INPUT, INVALID_CLIENT_ID, IMAGE_UPLOAD_ERROR, BENEFIT_FILE_TOO_LARGE, BENEFIT_INVALID_IMAGE_TYPE
- 409: BENEFIT_ALREADY_EXISTS

    * @method
    * @name CoreApi#adminCreateBenefit
    */
  adminCreateBenefit(
    parameters: {} = {},
    form: BenefitCreate,
  ): Promise<{
    benefit_id: string;
  }> {
    let path = "/admin/gamification/benefits";
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append("Content-Type", "multipart/form-data");
    headers.append("Accept", "application/json");

    return this.request(
      "POST",
      `${this.baseUrl}${path}`,
      form,
      headers,
      queryParameters,
    );
  }
  /**
   * Get benefit detail as an admin
   * @method
   * @name CoreApi#adminGetBenefitDetail
   */
  adminGetBenefitDetail(
    benefitId: string,
    parameters: {} = {},
  ): Promise<BenefitDetail> {
    let path = "/admin/gamification/benefits/{benefitId}";
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append("Accept", "application/json");

    path = path.replace("{benefitId}", benefitId.toString());

    return this.request(
      "GET",
      `${this.baseUrl}${path}`,
      {},
      headers,
      queryParameters,
    );
  }
  /**
    * Update benefit detail

Chyby, ktoré môže endpoint vrátiť:
- 400: INVALID_POINTS, IMAGE_UPLOAD_ERROR, BENEFIT_FILE_TOO_LARGE, BENEFIT_INVALID_IMAGE_TYPE
- 404: BENEFIT_NOT_FOUND

    * @method
    * @name CoreApi#adminUpdateBenefit
    */
  adminUpdateBenefit(
    benefitId: string,
    parameters: {} = {},
    form: BenefitUpdate,
  ): Promise<void> {
    let path = "/admin/gamification/benefits/{benefitId}";
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append("Content-Type", "multipart/form-data");
    headers.append("Accept", "application/json");

    path = path.replace("{benefitId}", benefitId.toString());

    return this.request(
      "PATCH",
      `${this.baseUrl}${path}`,
      form,
      headers,
      queryParameters,
    );
  }
  /**
   * Delete benefit
   * @method
   * @name CoreApi#adminDeleteBenefit
   */
  adminDeleteBenefit(benefitId: string, parameters: {} = {}): Promise<void> {
    let path = "/admin/gamification/benefits/{benefitId}";
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append("Accept", "application/json");

    path = path.replace("{benefitId}", benefitId.toString());

    return this.request(
      "DELETE",
      `${this.baseUrl}${path}`,
      {},
      headers,
      queryParameters,
    );
  }
  /**
    * Správy aplikácie určené všetkým, teda `audience: all`, po odfiltrovaní
okna platnosti.

Tento endpoint je verejný a nevyžaduje autentifikáciu — banner
oznamujúci odstávku musí byť čitateľný aj pre neprihláseného
návštevníka. Správy cielené na prihlásených alebo na rolu sa odtiaľto
nikdy nevracajú; na tie je `/me/messages` s tokenom.

Pre neznámy `client_id` vracia prázdny zoznam, nie 404 — endpoint tak
neprezradí, ktoré aplikácie na platforme existujú.

    * @method
    * @name CoreApi#publicGetClientMessages
    */
  publicGetClientMessages(
    clientId: string,
    parameters: {} = {},
  ): Promise<ClientMessagesResponse> {
    let path = "/public/clients/{client_id}/messages";
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append("Accept", "application/json");

    path = path.replace("{client_id}", clientId.toString());

    return this.request(
      "GET",
      `${this.baseUrl}${path}`,
      {},
      headers,
      queryParameters,
    );
  }
  /**
    * Získa zoznam všetkých dostupných benefitov pre gamifikáciu.

Tento endpoint je verejný a nevyžaduje autentifikáciu.
Vráti všetky benefity s ich základnými informáciami.

    * @method
    * @name CoreApi#publicGetGamificationBenefits
    */
  publicGetGamificationBenefits(parameters: {} = {}): Promise<{
    benefits: Array<BenefitListItem>;
  }> {
    let path = "/public/gamification/benefits";
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append("Accept", "application/json");

    return this.request(
      "GET",
      `${this.baseUrl}${path}`,
      {},
      headers,
      queryParameters,
    );
  }
  /**
    * Získa zoznam všetkých dostupných otvorených dát.

Tento endpoint je verejný a nevyžaduje autentifikáciu.
Vráti všetky otvorené dáta s ich základnými informáciami.

    * @method
    * @name CoreApi#gatherOpenData
    */
  gatherOpenData(parameters: {} = {}): Promise<{}> {
    let path = "/open-data";
    let headers: Headers = new Headers();
    let queryParameters: QueryParameters = {};

    headers = this.appendAuthHeaders(headers);
    headers.append("Accept", "application/json");

    return this.request(
      "GET",
      `${this.baseUrl}${path}`,
      {},
      headers,
      queryParameters,
    );
  }
}

const client = new CoreApi();
client.setBaseUrl(config.VITE_CORE_API_URL);
export default CoreApiTokenManager.authApiProxy(networkErrorApiWrapper(urnApiWrapper(client, 'CoreApi')));
export { CoreApi };
